import { useReactiveVar } from '@apollo/client';
import { EuiFormLabel } from '@elastic/eui';
import { vehicleKM } from 'cache';
import { RangeFilter } from 'components/RangeFilter/RangeFilter';
import { kmOptions } from 'enums/G';
import { useIntl } from 'react-intl';
import { getOptions } from 'utils/getOptions';

import * as S from './FiltersSidebar.styles';

export const VehicleKMFilter = (): JSX.Element => {
  const { formatMessage } = useIntl();
  const options = useReactiveVar(vehicleKM);

  return (
    <S.SidebarFilterWrapper>
      <EuiFormLabel>{formatMessage({ id: 'filters.vehicleKM.label' })}</EuiFormLabel>
      <RangeFilter values={options as { min: string; max: string }} onChange={vehicleKM} data={getOptions(kmOptions)} />
    </S.SidebarFilterWrapper>
  );
};
